import { __assign, __rest } from "tslib";
/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Modal.Subcomponent` filename
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Modal.Body.scss';
var ModalBody = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({}, props, { className: classnames('ModalBody', className) }), children));
};
ModalBody.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};
export default ModalBody;
//# sourceMappingURL=Modal.Body.js.map